module.exports = __webpack_public_path__ + "img/The_Spotted_Cow@2x.8177b3c1.png";